import React from 'react';
import { CTAButton } from './CTAButton';
const stats = [{
  value: '100+',
  label: 'Clinical tools & resources'
}, {
  value: '6',
  label: 'Clinical volumes'
}, {
  value: '7',
  label: 'Core decision steps'
}, {
  value: '15 min',
  label: 'To structure your assessment'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-navy-950 px-4 pb-12 pt-8 sm:px-6 sm:pb-16 sm:pt-10" data-id="element-169" data-mp="4mruz2uyk3ma">
      <div className="mx-auto max-w-4xl" data-id="element-170" data-mp="12861s1aa6gsn">
        <p className="text-center font-display text-sm font-600 uppercase tracking-[0.4em] text-gold-400" data-id="element-171" data-mp="1274l9hahx23j">
          Dr. Karito
        </p>

        <h1 className="mt-5 text-center font-display text-4xl font-700 uppercase leading-[0.95] text-white sm:text-6xl" data-id="element-172" data-mp="sa9q98dflju0">
          DVO Master
          <br data-id="element-173" data-mp="neauv0tor1k3" />
          <span className="text-gold-400" data-id="element-174" data-mp="3d1ikl9ryvcnf">Protocol™</span>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-center text-lg font-600 leading-snug text-clay sm:text-2xl" data-id="element-175" data-mp="3d2tqbf4z2uh6">
          Organize Your Vertical Dimension Assessment in 15 Minutes — With a 7-Step Clinical
          Decision System
        </p>

        <div className="mx-auto mt-7 max-w-2xl" data-id="element-176" data-mp="3o7c4291259lw">
          <img src="https://cdn.magicpatterns.com/uploads/tKBKaDSqxLVQoM7ALoemFg/DVO-EN.png" alt="DVO Master Protocol™ complete 6-volume clinical system with worksheets, quick cards and digital editions" className="w-full" width={1080} height={1080} data-id="element-177" data-mp="3o73q0dt77y94" />
        </div>

        <p className="mx-auto mt-2 max-w-xl text-center text-sm leading-relaxed text-slate-300 sm:text-base" data-id="element-178" data-mp="358rdqj6zq89b">
          Stop second-guessing what to assess, what to record, and what to validate before moving
          forward. DVO Master Protocol™ gives restorative dentists a structured clinical system to
          organize the assessment of Vertical Dimension of Occlusion using clear decision
          frameworks, checklists, clinical worksheets, and validation protocols.
        </p>

        <div id="first-cta" className="mx-auto mt-7 max-w-md" data-id="element-179" data-mp="2lmlcqwic61g4">
          <CTAButton label="Get instant access now" subtext="Instant digital access · No subscription · Lifetime access · 7-day guarantee" data-id="element-180" data-mp="s3mcu1g2bwxu" />
        </div>

        <dl className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-4" data-id="element-181" data-mp="id02omr47ymj">
          {stats.map(stat => <div key={stat.label} className="flex flex-col justify-between rounded-xl border border-white/10 bg-navy-900 p-4 text-center" data-id="element-182" data-mp="degiaqs66uwa">
              <dt className="order-2 mt-2 text-[10px] font-600 uppercase leading-tight tracking-[0.12em] text-slate-400" data-id="element-183" data-mp="162uf537ivl69">
                {stat.label}
              </dt>
              <dd className="order-1 font-display text-3xl font-700 text-gold-400 sm:text-4xl" data-id="element-184" data-mp="x1eevoaf8zfr">
                {stat.value}
              </dd>
            </div>)}
        </dl>
      </div>
    </header>;
}